module.exports = __webpack_public_path__ + "img/tour-5.4267e162.png";